import { getAppUrl } from "../appV2/environment/getAppUrl";
import { EMAIL_LOGIN_LINK_PATH } from "../appV2/Auth/AuthRedirect/paths";

export function getSignInLink(requestedURL: string, email: string): string {
  const appDomain = getAppUrl();

  const searchParams = new URLSearchParams({
    requestedUrl: requestedURL,
    email,
  });

  return `${appDomain}${EMAIL_LOGIN_LINK_PATH}?${searchParams}`;
}
